var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139,
    height: 122,
    viewBox: "0 0 139 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2634",
    x: -3,
    y: 2,
    width: 145,
    height: 125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-LP_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 122
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LP_icon",
    clipPath: "url(#clip-LP_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_2634)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2634-2",
    "data-name": "Rectangle 2634",
    width: 127,
    height: 107,
    rx: 6,
    transform: "translate(6 8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(11.66 -4.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M92.888,165.332h36.2l5.137-4.677a.894.894,0,0,0,0-1.322l-5.137-4.677h-36.2a5.338,5.338,0,0,0,0,10.676Zm0,0",
    transform: "translate(-69.349 -122.503)",
    fill: "#fb918a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M111.465,154.656H92.888a5.338,5.338,0,0,0,0,10.675h18.577A5.8,5.8,0,0,1,111.465,154.656Zm0,0",
    transform: "translate(-69.349 -122.503)",
    fill: "#f46969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M309.541,154.656H274.585l5.137,4.677a.893.893,0,0,1,0,1.321l-5.137,4.677h34.956a7.89,7.89,0,1,1,0,15.78H276.66l-5.137,4.677a.893.893,0,0,0,0,1.321l5.137,4.677h32.881a18.45,18.45,0,0,0,10.132-3.019,53.419,53.419,0,0,0-1.944-32.2,18.448,18.448,0,0,0-8.188-1.908Zm0,0",
    transform: "translate(-214.842 -122.503)",
    fill: "#f7df9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M78.72,313.094l-10.883-8.286a.893.893,0,0,0-1.433.71v2.845H28.116a7.89,7.89,0,0,1,0-15.78H69.383l-5.137-4.677a.894.894,0,0,1,0-1.322l5.137-4.677H28.116a18.566,18.566,0,0,0,0,37.131H66.4v3.051a.893.893,0,0,0,1.433.711l10.883-8.286A.892.892,0,0,0,78.72,313.094Zm0,0",
    transform: "translate(-7.565 -223.298)",
    fill: "#409ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M92.768,154.672a5.336,5.336,0,1,0,5.218,5.335A5.337,5.337,0,0,0,92.768,154.672Zm0,0",
    transform: "translate(-69.349 -122.516)",
    fill: "#ea5454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M498.18,411.969ZM498.277,412.118Zm0,0",
    transform: "translate(-394.608 -326.321)",
    fill: "#409ff5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M49.76,308.362H28.116a7.89,7.89,0,1,1,0-15.779h21.6a5.779,5.779,0,0,1,0-10.676h-21.6a18.565,18.565,0,0,0,0,37.131H49.664a5.779,5.779,0,0,1,.1-10.676Zm0,0",
    transform: "translate(-7.565 -223.299)",
    fill: "#0e8ddb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_47",
    "data-name": "Subtraction 47",
    d: "M25.5,40.894h0V36.735a6.535,6.535,0,0,0,2.79,1.378.508.508,0,0,0,.3-.081A57.571,57.571,0,0,0,26.885,6.7c-.45-.246-.916-.472-1.386-.671V5.106a15.477,15.477,0,0,1,9.739,5.168A18.894,18.894,0,0,1,40,23a18.89,18.89,0,0,1-4.762,12.726A15.474,15.474,0,0,1,25.5,40.894Z",
    transform: "translate(85.354 22.441)",
    fill: "#f7df9a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_830",
    "data-name": "Ellipse 830",
    cx: 12.312,
    cy: 12.312,
    rx: 12.312,
    ry: 12.312,
    transform: "translate(22.75 19.836)",
    fill: "#063e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M260.7,378.851a6.629,6.629,0,1,1,6.629-6.629A6.637,6.637,0,0,1,260.7,378.851Z",
    transform: "translate(-225.638 -340.074)",
    fill: "#13599a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M280.964,394.38a1.894,1.894,0,1,1,1.894-1.894A1.9,1.9,0,0,1,280.964,394.38Zm0-1.894-.011,0Zm0,0Zm0,0Zm0,0h0ZM280.966,392.486ZM280.967,392.486Zm0,0ZM280.967,392.486Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0ZM280.971,392.485ZM280.971,392.485ZM280.971,392.485Zm0,0h0Zm0,0h0Z",
    transform: "translate(-245.902 -360.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_831",
    "data-name": "Ellipse 831",
    cx: 12.259,
    cy: 6.632,
    rx: 12.259,
    ry: 6.632,
    transform: "translate(81.166 89.899)",
    fill: "#13599a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M333.955,100.118a4.806,4.806,0,0,0-2.027-3.645c6.17.357,10.975,3.172,10.975,6.593,0,3.663-5.508,6.632-12.3,6.632-4.3,0-8.077-1.188-10.277-2.987.437.025.88.039,1.329.039C328.446,106.751,333.955,103.782,333.955,100.118Z",
    transform: "translate(-237.221 -6.534)",
    fill: "#063e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M172.872,11.063h11.369v7.986H172.872Z",
    transform: "translate(-78.992 64.803)",
    fill: "#f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M175.882,11.063h-3.01v7.986h11.369V16.038h-4.983a3.376,3.376,0,0,1-3.376-3.376Z",
    transform: "translate(-78.992 64.803)",
    fill: "#f92174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M169.694,23.48a.841.841,0,0,1-.812-.868V3.276a.814.814,0,1,1,1.624,0V22.612A.841.841,0,0,1,169.694,23.48Z",
    transform: "translate(-75.65 72.052)",
    fill: "#c7cfe1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpIcon);
export default __webpack_public_path__ + "static/media/LP_icon.ae2ecbe7.svg";
export { ForwardRef as ReactComponent };